import { render, staticRenderFns } from "./AddCard.vue?vue&type=template&id=6406b440&scoped=true&"
import script from "./AddCard.vue?vue&type=script&lang=ts&"
export * from "./AddCard.vue?vue&type=script&lang=ts&"
import style0 from "./AddCard.vue?vue&type=style&index=0&id=6406b440&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6406b440",
  null
  
)

export default component.exports